/**
 * Maps curriculum-service course trees to the legacy course-manager-sdk shape
 * so existing helpers can keep using `contentfulId`, `leaf`, and `leafNodeId`.
 */

const transformNode = node => {
  if (!node || typeof node !== 'object') return node

  const transformed = {
    ...node,
    contentfulId: node.contentfulId ?? node.externalId ?? null,
    leaf: node.leaf ?? node.isLeaf ?? false,
    leafNodeId:
      node.leafNodeId ?? node.leafExternalId ?? node.leafCompositeId ?? null,
    requirementType: node.requirementType ?? undefined,
  }

  if (Array.isArray(node.children)) {
    transformed.children = node.children.map(transformNode)
  }

  return transformed
}

/**
 * Accepts a full `/v1/audienced-course-versions` response (`{ tree }`) or a bare
 * tree node. Returns null when no tree is present.
 */
export const transformCurriculumCourseTree = input => {
  if (!input || typeof input !== 'object') return null

  const isResponseWrapper = Object.prototype.hasOwnProperty.call(input, 'tree')
  const tree = isResponseWrapper ? input.tree : input

  if (!tree || typeof tree !== 'object') return null

  return transformNode(tree)
}

/**
 * Transforms `{ [courseCode]: curriculumServiceResponse }` into legacy-shaped
 * trees keyed by courseCode.
 */
export const transformCurriculumCourseTrees = curriculumCourseMap => {
  if (!curriculumCourseMap || typeof curriculumCourseMap !== 'object') {
    return {}
  }
  const trees = {}
  for (const [courseCode, payload] of Object.entries(curriculumCourseMap)) {
    const tree = transformCurriculumCourseTree(payload)
    if (tree) trees[courseCode] = tree
  }
  return trees
}
